module.exports = require('./dist').default;
module.exports.default = module.exports;




//////////////////
// WEBPACK FOOTER
// ./~/inferno-component/index.js
// module id = 29
// module chunks = 0